<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <h3 v-if="mData.viewMode === 'create'">THÊM MỚI QR SCAN</h3>
        <h3 v-if="mData.viewMode === 'update'">CẬP NHẬT QR SCAN</h3>
      </div>

      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="validForm"
          ref="myForm"
          label-position="top"
        >
          <el-form-item
            label="Mã code"
            prop="code"
            v-if="this.mData.viewMode === 'create'"
          >
            <el-input
              v-model="mData.dataForm.code"
              :disabled="mData.viewMode == 'detail'"
              clearable
              @input="forceUpdateUI"
              @change="mData.dataForm.code = mData.dataForm.code.trim()"
            ></el-input>
          </el-form-item>
          <el-form-item label="URL" prop="pattern_url">
            <el-input
              v-model="mData.dataForm.pattern_url"
              :disabled="mData.viewMode == 'detail'"
              clearable
              @input="forceUpdateUI"
              @change="
                mData.dataForm.pattern_url = mData.dataForm.pattern_url.trim()
              "
            ></el-input>
          </el-form-item>

          <div class="text-center mt-3">
            <el-button
              type="danger"
              plain
              @click="fn_cancel()"
              v-ladda
              v-if="mData.viewMode === 'update' || mData.viewMode === 'create'"
              >hủy</el-button
            >
            <el-button
              type="primary"
              @click="fn_add()"
              v-ladda
              v-if="mData.viewMode === 'create'"
              >thêm mới</el-button
            >
            <el-button
              type="primary"
              @click="fn_update()"
              v-ladda
              v-if="mData.viewMode === 'update'"
              >cập nhật</el-button
            >
            <el-button
              type="primary"
              @click="fn_back()"
              v-ladda
              v-if="mData.viewMode === 'detail'"
              >quay lại</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import ValidService from "../../../service/ValidService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormCauHoiThuongGap";
import { Circle4 } from "vue-loading-spinner";
export default {
  components: {
    Circle4,
  },
  data() {
    return {
      loading: true,
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
      validForm: {
        code: [
          ValidService.required,
          ValidService.checkSpaceString,
          ValidService.checkCampaign,
        ],
        pattern_url: [ValidService.required, ValidService.checkURL],
      },
    };
  },
  methods: {
    async fn_initForm() {
      try {
        const response = await mushroom.qr_scan.listAsync({
          filters: ["id=" + this.$router.currentRoute.params.id],
          fields: "id,code,pattern_url",
        });
        this.mData.dataForm = response.result[0];
        this.loading = false;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    // thêm mới qr scan
    async fn_add() {
      const qrscan_object = {
        code: this.mData.dataForm.code,
        pattern_url: this.mData.dataForm.pattern_url,
      };
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          try {
            await mushroom.qr_scan.createAsync(qrscan_object);
            MethodService.stopLadda();
            this.fn_resetForm();
            window.toastr.success("Thêm mới QRScan thành công");
            this.$router.push({
              name: "DanhSachQRScan",
            });
          } catch (e) {
            if (e.meta.field == "$unique_key") {
              window.toastr.error("Mã QRScan đã tồn tại");
            } else MethodService.showError(e.code);
          } finally {
            MethodService.stopLadda();
          }
        } else MethodService.stopLadda();
      });
    },

    // cập nhật
    async fn_update() {
      const update_qrcode_object = {
        id: this.$router.currentRoute.params.id,
        pattern_url: this.mData.dataForm.pattern_url,
      };
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          try {
            const response = await mushroom.qr_scan.partialUpdateAsync(
              update_qrcode_object
            );
            if (response.result == update_qrcode_object.id) {
              window.toastr.success("Cập nhật thành công");
              this.$router.push({
                name: "DanhSachQRScan",
              });
            } else window.toastr.warning("Dữ liệu không thay đổi");
          } catch (e) {
            MethodService.showError(e.code);
          } finally {
            MethodService.stopLadda();
          }
        } else MethodService.stopLadda();
      });
    },

    fn_back() {
      this.$router.go(-1);
    },

    // reset form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },

    fn_cancel() {
      this.fn_resetForm();
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
  },

  async created() {
    if (this.$router.currentRoute.name == "TaoQRScan") {
      this.mData.viewMode = "create";
      this.loading = false;
    }
    if (this.$router.currentRoute.name == "CapNhatQRScan") {
      this.mData.viewMode = "update";
      await this.fn_initForm();
    }
  },
};
</script>

